import * as React from 'react';
import { Empty } from 'antd';

const SelectorEmpty = () => (
  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ margin: '8px 0' }} />
);

export default React.memo(SelectorEmpty);
